<template lang="pug">
  .media_container.page_container
    .page_header
      .page_header_column
        b-field
          b-input(
            v-model="infiniteScroll.keyword"
            placeholder="キーワードで検索"
            type="search"
            icon="search"
            rounded
            size="is-medium"
            @input="getMediaList('search')")
      .page_header_column
        b-button(
          type="is-info"
          size="is-medium"
          outlined
          icon-left="image-upload"
          @click="activeUploadModal()") 画像アップロード
    b-loading(v-model="infiniteScroll.isLoading" :is-full-page="isFullPage")
    ul.media_list#js_media_list(v-if="mediaList.length > 0")
      li.media_item(v-for=" (media, index) in mediaList ")
        .card
          a.card-image(href="#" aria-label="画像詳細のポップアップを開く" @click.prevent="activeMediaModal(index)")
            .image.is-4by3(:style="'background-image: url('+media.url+')'")
          .card-content
            .media-content
              b-switch(
                v-model="media.release_flag"
                size="is-medium"
                @input="updateImage(media.release_flag, media.id)") {{ media.release_flag === true ? 'メディア一覧にのせる' : 'メディア一覧にのせない' }}
    b-message._empty(v-else-if="!isInitialLoading") 該当する画像はありません

    // 画像アップロードモーダル
    b-modal.media_upload_modal(v-model="uploadModal.isActive" :width="1000")
      .card
        .media_upload_modal_title 画像アップロード
        b-upload(
          v-if="!uploadModal.isLoading"
          v-model="uploadModal.file"
          drag-drop
          expanded
          accept="image/jpeg, image/png, image/gif"
          size="is-medium")
          section.section
            .content.has-text-centered
              p
                b-icon(icon="image-upload")
              p.is-size-5
                | アップロードするファイルをドロップ
                br
                | または
                br
                | ファイルを選択
        .media_upload_modal_content
          .media_upload_modal_fileName.mt-6(v-if="uploadModal.file" :class="uploadModal.className")
            p
              span.has-text-weight-bold ファイル名：
              span {{ uploadModal.file.name }}
          b-switch.mt-5(v-model="uploadModal.release_flag" size="is-medium" width="20")
            span {{ uploadModal.release_flag === true ? 'メディア一覧にのせる' : 'メディア一覧にのせない' }}
          b-button.is-block.mt-6(
            v-if="uploadModal.file"
            type="is-info"
            size="is-medium"
            :loading="uploadModal.isLoading"
            :class="uploadModal.buttonClassName"
            @click="uploadImage()") 画像をアップロードする
    // 画像詳細モーダル
    b-modal.media_modal(v-model="mediaModal.isActive" :width="1000")
      .card(v-if="mediaModal.data")
        template(v-if="mediaModal.page === 'detail'")
          b-loading(v-model="mediaModal.isLoading" :is-full-page="mediaModal.isFullPage")
          .card-image
            figure.image
              img(:src="mediaModal.data.url")
          .card-content
            .media-content
              .media_modal_buttons
                b-button.media_modal_edit(
                  type="is-info"
                  size="is-medium"
                  outlined
                  icon-left="image-edit"
                  @click="switchMediaModalPage('edit')") 編集する
                b-button.button.ui-button.media_modal_duplicate(
                  type="is-info"
                  size="is-medium"
                  outlined
                  icon-left="copy"
                  :loading="mediaModal.duplicate.isLoading"
                  @click="duplicateConfirm()") 複製する
              p.mb-1.is-size-5
                span.has-text-weight-bold ファイル名：
                span {{ mediaModal.data.name }}
              p.mb-4.is-size-5
                span.has-text-weight-bold サイズ：
                span {{ mediaModal.size.width }} × {{ mediaModal.size.height }} px
              b-field(v-if="mediaModal.data.url")
                b-input(v-model="mediaModal.data.url" readonly expanded)
                p.control
                  b-button(
                    type="is-primary"
                    v-clipboard:copy="mediaModal.data.url"
                    v-clipboard:success="onCopySuccess"
                    v-clipboard:error="onCopyError") Copy
              .media_modal_option
                b-switch(
                  v-model="mediaModal.data.release_flag"
                  size="is-medium"
                  @input="updateImage(mediaModal.data.release_flag, mediaModal.data.id)") {{ mediaModal.data.release_flag === true ? 'メディア一覧にのせる' : 'メディア一覧にのせない' }}
                .media_modal_delete
                  a.has-text-danger(@click="deleteConfirm(mediaModal.data.id)") 削除する
        template(v-else)
          image-editor(
            :mediaData="mediaModal"
            @switchMediaModalPage="switchMediaModalPage"
            @getMediaList="getMediaList('save')")

</template>

<script>
import ImageEditor from '@/components/ImageEditor.vue'

export default {
  name: 'Media',
  head: {
    title() {
      return {
        inner: 'メディア',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  components: {
    ImageEditor,
  },
  data: function(){
    return {
      mediaList: new Array(),
      isInitialLoading: true,
      isFullPage: true,
      mediaModal: {
        data: null,
        size: {
          width: 0,
          height: 0
        },
        page: null,
        // 選択中の画像のindex
        index: 0,
        duplicate: {
          isLoading: false,
        },
        // b-loading
        isLoading: false,
        isFullPage: false,
        isActive: false
      },
      uploadModal: {
        file: null,
        release_flag: false,
        className: null,
        buttonClassName: null,
        isLoading: false,
        isFullPage: false,
        isActive: false
      },

      infiniteScroll: {
        limit: 40,
        offset: 0,
        keyword: '',
        isLastPage: false, // 無限スクロール終了時にtrue
        isLoading: false,
      }
    }
  },
  created() {
    this.getMediaList()
    window.addEventListener('scroll', this.mediaScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.mediaScroll)
  },
  watch: {
    'uploadModal.isActive': function(){
      this.uploadModal.file = null
    },
    'uploadModal.file': function(){
      this.uploadModal.className = 'animated_opacity'
      this.uploadModal.buttonClassName = 'animated_bound'
      setTimeout(
        function() {
          this.$nextTick(function(){
            this.uploadModal.className = null
            this.uploadModal.buttonClassName = null
          })
        }.bind(this),
        500 // .animated_bound の animation-durationより長く
      )
    },
  },
  methods: {
    activeMediaModal(index){
      this.mediaModal.index = index
      this.mediaModal.data = this.mediaList[index]
      this.mediaModal.page = 'detail'
      this.mediaModal.isActive = true
      this.getImageSize()
    },
    activeUploadModal(){
      this.uploadModal.isActive = true
    },
    getImageSize(){
      this.mediaModal.isLoading = true
      const img = new Image()
      img.crossOrigin = "anonymous"
      img.src = this.mediaModal.data.url
      img.onload = () => {
        this.mediaModal.size.width = img.width
        this.mediaModal.size.height = img.height

        this.mediaModal.isLoading = false
      }
    },
    onCopySuccess(){
      this.$buefy.toast.open({
        duration: 2000,
        message: 'URLをコピーしました',
        type: 'is-success'
      })
    },
    onCopyError(){
      this.$buefy.toast.open({
        duration: 2000,
        message: 'URLのコピーに失敗しました',
        type: 'is-danger'
      })
    },
    duplicateConfirm(){
      this.$buefy.dialog.confirm({
        title: '画像を複製しますか？',
        message: '複製した画像は一覧の最上部に追加されます。',
        confirmText: '複製する',
        cancelText: 'キャンセル',
        type: 'is-info',
        size: 'is-medium',
        hasIcon: false,
        onConfirm: () => {
          this.duplicateImage()
        }
      })
    },
    deleteConfirm(id){
      this.$buefy.dialog.confirm({
        title: '画像を削除しますか？',
        message: '削除した画像は復元できません。',
        confirmText: '画像を削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.deleteImage(id)
        }
      })
    },
    switchMediaModalPage(pageType) {
      this.mediaModal.page = pageType
      if( pageType === 'detail' ) {
        this.getImageSize()
      }
    },
    mediaScroll() {
      const elm = document.getElementById('js_media_list')
      const HeightAdjustment = 80

      if( elm && !this.infiniteScroll.isLastPage ){
        // 最下部の画像が画面に入ったら次のページを読み込む
        if( elm.getBoundingClientRect().bottom < window.innerHeight + HeightAdjustment){
          if(this.infiniteScroll.isLoading === false){
            this.getMediaList('scroll')
          }
        }
      }
    },
    async getMediaList(type) {
      try {
        this.infiniteScroll.isLoading = true

        if( type !== 'scroll' ) this.infiniteScroll.offset = 0

        const data_obj = {
          keyword: this.infiniteScroll.keyword,
          limit: this.infiniteScroll.limit,
          offset: this.infiniteScroll.offset,
        }

        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES,
          { params: data_obj }
        )

        const r = res.data
        if( r.status == 1 ){
          const data = r.data

          if( type === 'search' || type === 'upload' ) { // キーワード検索 ・ アップロード
            this.mediaList = data
          } else if( type === 'duplicate' || type === 'save' || type === 'delete' ) { // 複製 ・ 編集して保存 ・ 削除
            this.mediaList = new Array()

            this.$nextTick(function() {
              this.mediaList = data

              // 一覧画像キャッシュ対策
              const current_unixtime = Date.now()
              this.mediaList[this.mediaModal.index].url += ('?time=' + current_unixtime)

              this.mediaModal.data = this.mediaList[this.mediaModal.index]
            })
          } else {
            this.mediaList = this.mediaList.concat(data)
          }

          this.$nextTick(function() {
            this.infiniteScroll.offset += this.infiniteScroll.limit

            // 画像一覧の総数＝該当の画像の総数となった時点で、無限スクロールストップ
            this.infiniteScroll.isLastPage = ( this.mediaList.length === r.meta.total_count ) ? true : false

            if( type !== 'scroll' ) {
              window.scrollTo(0, 0)
            }
          })
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像一覧の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.infiniteScroll.isLoading = false
        this.isInitialLoading = false
      }
    },
    async uploadImage() {
      try {
        this.uploadModal.isLoading = true
        const formData = new FormData()
        formData.append('image[image]', this.uploadModal.file)
        formData.append('image[release_flag]', this.uploadModal.release_flag)

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES,
          formData,
          config
        )

        const r = res.data
        if( r.status == 1 ){
          this.getMediaList('upload')
          this.uploadModal.isActive = false
          this.$common.createSuccessMessage('画像をアップロードしました')
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else if(r.errors.status == 58) {
            this.$common.createErrorMessage(r.errors, '画像のアップロードは「.jpg形式、.jpeg形式、.gif形式、.png形式」のみ対応しています。')
          } else {
            this.$common.createErrorMessage(r.errors, '画像のアップロードに失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.uploadModal.isLoading = false
      }
    },
    async duplicateImage() {
      try {
        this.mediaModal.duplicate.isLoading = true

        const fileName = this.mediaModal.data.name
        const index = fileName.indexOf('.')
        const extension = fileName.slice(index + 1)
        const mineType = (function() {
          if ( extension === 'png' ) {
            return 'image/png'
          } else if( extension === 'jpeg' || extension === 'jpg' ) {
            return 'image/jpeg'
          } else if( extension === 'gif' ) {
            return 'image/gif'
          }
        })();

        const toDataURL = url => fetch(url)
          .then(response => response.blob())
          .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          }))

        const base64 = await toDataURL(this.mediaModal.data.url)

        const bin = atob(base64.replace(/^.*,/,''))
        const buffer = new Uint8Array(bin.length)
        for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i)
        }
        const file = new File([buffer.buffer], fileName ,{ type: mineType })

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const formData = new FormData()
        formData.append('image[image]', file)
        formData.append('image[release_flag]', false) // 複製なのでfalse

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES,
          formData,
          config
        )

        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像を複製しました')
          this.getMediaList('duplicate')
          this.mediaModal.isActive = false
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像の複製に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.mediaModal.duplicate.isLoading = false
      }
    },
    async updateImage(release_flag, id) {
      try{
        const formData = new FormData()
        formData.append('image[release_flag]', release_flag)

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES_.replace(':id', id),
          formData,
          config
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像情報を更新しました')
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像情報の更新に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async deleteImage(id) {
      try{
        const res = await this.$axios.delete(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES_.replace(':id', id)
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像を削除しました')
          this.getMediaList('delete')
          this.mediaModal.isActive = false
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像の削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>
